'use client'

import { EditableText } from '../functionality/EditableText'

export const BLOCK_BADGE_VARIANTS = Object.freeze({
  purple: 'badge-purple',
  green: 'badge-green',
  amber: 'badge-amber',
  blue: 'badge-blue',
  red: 'badge-red',
})

/** Semantic presets — match original bible badge usage */
export const BADGE_PRESETS = Object.freeze([
  { variant: 'purple', label: 'Focus', sample: 'most important' },
  { variant: 'green', label: 'Resume signal', sample: 'resume signal' },
  { variant: 'amber', label: 'Prepare these', sample: 'prepare these' },
  { variant: 'blue', label: 'Use these', sample: 'use these' },
  { variant: 'red', label: 'Non-negotiable', sample: 'non-negotiable' },
])

export function BlockBadge({
  text,
  variant = 'purple',
  onSave,
  onPress,
  instanceKey,
  className = '',
}) {
  if (!onSave && !text) return null

  const variantClass = BLOCK_BADGE_VARIANTS[variant] ?? BLOCK_BADGE_VARIANTS.purple

  return (
    <div
      className={`badge ${variantClass} nb-badge-chip ${className}`.trim()}
      style={{ display: 'inline-flex' }}
      role={onPress ? 'button' : undefined}
      tabIndex={onPress ? 0 : undefined}
      onClick={onPress}
      onKeyDown={
        onPress
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                onPress(e)
              }
            }
          : undefined
      }
    >
      {onSave ? (
        <EditableText
          instanceKey={instanceKey}
          value={text ?? ''}
          onSave={onSave}
          multiline={false}
          inline
          richText={false}
          bubbleToolbar={false}
        />
      ) : (
        text
      )}
    </div>
  )
}
